var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 171,
    rx: 4,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3529 59.5294C62.4798 59.5294 58.5294 63.4798 58.5294 68.3529V92.3279L69.6585 81.1987C71.5263 79.4014 73.7722 78.3416 76.1765 78.3416C78.5807 78.3416 80.8264 79.4017 82.6942 81.199L82.7187 81.2225L92.0588 90.5632L94.3644 88.2576C96.2322 86.4603 98.4781 85.4005 100.882 85.4005C103.287 85.4005 105.532 86.4605 107.4 88.2578L107.425 88.2813L111.471 92.3279V68.3529C111.471 63.4798 107.52 59.5294 102.647 59.5294H67.3529ZM111.471 97.3192L104.941 90.7897C103.593 89.4973 102.192 88.9299 100.882 88.9299C99.5732 88.9299 98.1714 89.4973 96.8236 90.7897L94.5545 93.0588L100.365 98.8698C101.055 99.559 101.055 100.676 100.365 101.365C99.6763 102.055 98.559 102.055 97.8698 101.365L90.8123 94.308L90.8097 94.3054L80.2353 83.731C78.8875 82.4385 77.4857 81.871 76.1765 81.871C74.8673 81.871 73.4655 82.4385 72.1177 83.731L58.5294 97.3192V103.647C58.5294 108.52 62.4798 112.471 67.3529 112.471H102.647C107.52 112.471 111.471 108.52 111.471 103.647V97.3192ZM55 96.5885V103.647C55 110.469 60.5306 116 67.3529 116H102.647C109.469 116 115 110.469 115 103.647V68.3529C115 61.5306 109.469 56 102.647 56H67.3529C60.5306 56 55 61.5306 55 68.3529V96.5885ZM93.8235 71.8824C93.8235 70.9077 94.6136 70.1176 95.5882 70.1176H95.6235C96.5982 70.1176 97.3882 70.9077 97.3882 71.8824C97.3882 72.857 96.5982 73.6471 95.6235 73.6471H95.5882C94.6136 73.6471 93.8235 72.857 93.8235 71.8824Z",
    fill: "#1689CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.56e2bb8fd2d748b108d959ed102e1145.svg";
export { ForwardRef as ReactComponent };